module.exports = __webpack_public_path__ + "static/media/mask-tool.3c81fe9e.svg";